module.exports = __webpack_public_path__ + "img/tap.3bf26c32.png";